import { Suspense } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { log } from '@geisinger-web/shared-module';

import { useOnlineStatus } from '@leagueplatform/web-common';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { LeagueProvider } from '@leagueplatform/core';

import { initMasonryRegistry } from 'utils/init-masonry-registry';
import { config } from 'config';
import { appRoutes } from 'app-routes';
import { RootErrorBoundary } from 'components/root-error-boundary/root-error-boundary.component';
import { OfflinePage } from 'components/offline-page/offline-page.component';

initMasonryRegistry();

log('test message');

const LeagueProviderWrapper = () => {
  const { isOffline, isOnline } = useOnlineStatus();
  return (
    <LeagueProvider config={config}>
      <RootErrorBoundary>
        <Suspense fallback={<LoadingIndicator />}>
          {isOffline && <OfflinePage />}
          {isOnline && <Outlet />}
        </Suspense>
      </RootErrorBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </LeagueProvider>
  );
};

const router = createBrowserRouter([
  {
    element: <LeagueProviderWrapper />,
    children: appRoutes,
  },
]);

export const App = () => <RouterProvider router={router} />;
